import { useState, useLayoutEffect, useRef } from "react";
import { useMollieComponent } from "../../hooks/useMollieComponent";
import { Box } from "@otrium/core";

interface MollieComponentProps {
  type: string;
  name: string;
}

const MollieComponent: React.FC<MollieComponentProps> = ({ type, name }) => {
  const [errorMessage, setErrorMessage] = useState<string | false>(false);
  const componentRef = useRef<HTMLDivElement>(null);

  const { mollieComponent } = useMollieComponent(type) as {
    mollieComponent: any | undefined;
  };

  useLayoutEffect(() => {
    if (mollieComponent) {
      mollieComponent.mount(componentRef.current);
      mollieComponent.addEventListener("change", (event: any) => {
        if (event.error && event.touched) {
          setErrorMessage(event.error as string);
        } else {
          setErrorMessage(false);
        }
      });
    }

    return function cleanup() {
      if (mollieComponent) {
        mollieComponent.unmount();
      }
    };
  }, [mollieComponent]);

  return (
    <Box>
      <label className="label" htmlFor={type}>
        {name}
      </label>
      <div className="component-ref" id={type} ref={componentRef} />

      {errorMessage && <div className="component-error">{errorMessage}</div>}
    </Box>
  );
};

export default MollieComponent;
